import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ResponsivePicture } from '../../../../Shared/components/Image';
export const LightBoxLayout = (props)=>{
    const { image, updateIsOpen, isOpen } = props;
    return /*#__PURE__*/ _jsxs("div", {
        className: "lightbox",
        children: [
            /*#__PURE__*/ _jsx("div", {
                onClick: updateIsOpen,
                children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                    imgClassName: "image-block__image",
                    defaultImageUrl: image.imageUrlFallback,
                    cropsPerMedia: [
                        {
                            crops: [
                                {
                                    url: image.imageUrl,
                                    width: 420
                                },
                                {
                                    url: image.imageUrlLarge,
                                    width: 840
                                }
                            ]
                        }
                    ],
                    width: 420,
                    height: 320,
                    alt: image.imageAlt
                })
            }),
            isOpen && /*#__PURE__*/ _jsxs("div", {
                className: "overlay",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "close--btn",
                        onClick: updateIsOpen
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                            defaultImageUrl: image.imageUrlFallback,
                            cropsPerMedia: [
                                {
                                    crops: [
                                        {
                                            url: image.imageUrl,
                                            width: 420
                                        },
                                        {
                                            url: image.imageUrlLarge,
                                            width: 840
                                        }
                                    ]
                                }
                            ],
                            lazyload: false,
                            width: "100%",
                            height: "100%",
                            alt: image.imageAlt
                        })
                    })
                ]
            })
        ]
    });
};
